import DatePicker from "react-datepicker";
import React, { useRef, useState } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { ReactComponent as RightArrow } from "../../assets/images/icons/RightArrow.svg";

import { createPortal } from "react-dom";
import BasicSelect from "../Task/BasicSelect";
import moment from "moment";
import DateTimeCombo from "../Task/DateTimeCombo";
import TimePickerComponent from "./TimePickerComponent";
import { flattenTree } from "../../utils/utilityFunctions/stringUtility";
import DatePickerComponent from "./DatePickerComponent";
import { convertTimeToDateObj, getFlushedDate } from "../../utils/utilityFunctions/dateUtility";
import InputComponent from "./InputComponent";
import SelectComponent from "./SelectComponent";
import { color } from "framer-motion";
import isEqual from "lodash/isEqual";
import TextAreaComponent from "./TextAreaComponent";
import DelegationMultiSelect from "../Task/DelegationMultiSelect";
const roundUpToNextHalfHour = (time) => {
  // Extract hours and minutes from the input time
  const [hours, minutes] = time.split(":").map(Number);

  // Calculate the next half-hour mark
  const roundedMinutes = minutes < 30 ? 30 : 0;
  const roundedHours = minutes < 30 ? hours : (hours + 1) % 24;

  // Format hours and minutes into HH:MM with seconds always set to 00
  return `${String(roundedHours).padStart(2, "0")}:${String(roundedMinutes).padStart(2, "0")}:00`;
};

const generateTimeOptions = () => {
  const times = [];
  for (let i = 0; i < 24; i++) {
    const hour = i < 10 ? `0${i}` : i;
    times.push(`${hour}:00:00`);
    times.push(`${hour}:30:00`);
  }
  return times;
};

const FieldElements = ({
  id,
  name,
  InputEndIcon,
  label,
  value,
  onChange,
  placeholder,
  size = 1,
  disabled,
  isFormDisabled,
  selectionList,
  type,
  inputType = "text",
  formData = {},
  taskid,
  defaultOptions,
  dynamicOptions,
  apiCall,
  addButton,
  addButtonLabel,
  addButtonAction,
  isLoading,
  useFetchHook = () => {},
  hookPayload,
  noKeyboardNavigation,
  noDisabled,
  displayValueKey,
  displayName,
  updateTags,
  clickTrigger,
  isNegativeValue = false,
  className = "",
  labelKey = "label",
  valueKey = "value",
  valueKeyBased,
  handleGroupsValue,
  mandatory = false,
  apiCallParam,
  onClick,
  ...props
}) => {
  const datePickerRef = useRef(null);
  const defaultFetchHook = () => [null, {}];
  const [fetchFieldValues, { data: fieldValueList, isFetching: isFieldFetching }] = useFetchHook() || [() => {}, {}];
  const optionList =
    defaultOptions ||
    dynamicOptions ||
    fieldValueList?.data?.map((item) =>
      !valueKeyBased ? { label: item, value: item } : { label: item[labelKey], value: item[valueKey] }
    );
  const handleCallHook = () => {
    if (fetchFieldValues && Boolean(hookPayload)) {
      fetchFieldValues({ payload: hookPayload }, true);
    }
  };

  console.log(fieldValueList, "dynamicOptions");

  // const [tagOptions,setTagOptions] = useState([
  //   { value: "Tag1", label: "Tag 1", color: "#FF0000" },
  //   { value: "Tag2", label: "Tag 2", color: "#FACD26" },
  //   { value: "Tag3", label: "Tag 3", color: "#292E33" },
  //   { value: "Tag4", label: "Tag 4", color: "#FF0000" },
  //   { value: "Tag5", label: "Tag 5", color: "#FACD26" },
  //   { value: "Tag6", label: "Tag 6", color: "#292E33" },
  // ]);

  // const tagOptions = fieldValueList?.map((eachItem) => ({
  //   label: eachItem.tag_name,
  //   value: eachItem.id,
  //   color: eachItem?.colour_code,
  //   bg_code: eachItem?.bg_code,
  //   default_label: eachItem?.default_tag_name,
  // }));

  // Converting Date object to "HH:mm"
  const formatTime = (date) => {
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });
  };

  const TimeElement = ({ formKey, name, disabled, onChange }) => {
    const rawStartTime = formData?.[formKey] || "00:00:00"; // Default to "00:00:00" if undefined
    const roundedStartTime = roundUpToNextHalfHour(rawStartTime.slice(0, 5));

    return (
      <select
        name={name}
        value={roundedStartTime}
        onChange={onChange}
        className={`form-select ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} rounded border focus:outline-hidden focus:ring-0 focus:border-1D5D9B  w-full active:border active:border-DFE2E5 text-xs block h-7 py-0`}
        disabled={disabled}
      >
        {generateTimeOptions().map((time) => (
          <option key={time} value={time}>
            {time.slice(0, 5)}
          </option>
        ))}
      </select>
      // <LocalizationProvider dateAdapter={AdapterDayjs} >
      //       <DemoContainer components={['TimePicker']} >
      //            <TimePicker label="Basic time picker" />
      //       </DemoContainer>
      // </LocalizationProvider>
    );
  };
  // console.log(value,"value optionList aakash")
  // console.log(optionList,"optionList aakash 1")
  // console.log(optionList?.filter(
  //   (eachOption) =>
  //     ((JSON.stringify(value)) === (JSON.stringify(eachOption.value)))
  // ),"optionList aakash 2")
  console.log(value, name, "value name");

  switch (type) {
    case "select":
    case "dropdown":
      return (
        <BasicSelect
          options={optionList || []}
          selectedOptions={flattenTree(optionList || [])?.filter((eachOption) => {
            if (typeof eachOption === "object" && eachOption !== null) {
              return JSON.stringify(formData[name])?.toLowerCase() === JSON.stringify(eachOption.value)?.toLowerCase();
            } else {
              return String(formData[name])?.toLowerCase() === String(eachOption.value)?.toLowerCase();
            }
          })}
          onChange={onChange}
          showSearch={optionList?.length > 5}
          disabled={(disabled || isFormDisabled) && !noDisabled}
          id={id}
          name={name}
          value={value}
          displayValue={formData[displayValueKey] ?? displayName}
          label={label}
          apiCall={apiCall}
          apiCallParam={apiCallParam}
          dynamicOptions={dynamicOptions}
          isLoading={isLoading || isFieldFetching}
          addButton={addButton}
          addButtonLabel={addButtonLabel}
          addButtonAction={addButtonAction}
          useFetchHook={useFetchHook}
          handleCallHook={hookPayload && handleCallHook}
          noKeyboardNavigation={noKeyboardNavigation}
          // isOpen,onClose,ref,showSearch,name,value,onClick,id,disabled,selectedOptions,options
          className={`form-select rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0`}
        />
      );
    case "date":
      return (
        <div className="flex relative w-full custom-datepicker-container">
          <DatePickerComponent
            selected={getFlushedDate(formData[name])}
            id={id}
            name={name}
            value={formData?.[name] ? new Date(formData[name]) : null}
            onChange={(selectedDate) => {
              const formattedDate = selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : null;
              onChange({ target: { name, value: formattedDate } });
            }}
            popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
            dateFormat="dd-MM-yyyy"
            placeholder={placeholder || "Select Date"}
            className="custom-select bg-white rounded-sm focus:outline-hidden focus:ring-0 focus:border-1D5D9B w-full"
            maxDate={new Date("2050-01-01")}
            minDate={new Date("2001-01-01")}
            showYearDropdown
            showMonthDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={500}
            popperPlacement="bottom-end"
            size={"small"}
            innerClassName="h-[30px]"
          />
          {console.log(formData, "dateform")}

          {/* change Start date Praveen Malviya */}
          {/* <DatePicker
            selected={""}
            onChange={()=>{}}
            placeholderText="Start Date"
            // popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
            dateFormat={"dd-MM-yyyy"}
            // className={` rounded border ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 px-2`}
            // dropdownMode="select"
            // disabled={formData?.update_single_occurrence || isFormDisabled}
            // minDate={new Date()}
          />  */}
          {/* <div
            className="absolute right-0 top-0 flex items-center pointer-events-none h-full"
            onClick={() => datePickerRef.current?.setOpen(true)}
          >
            <CalendarInputEndIcon />
          </div> */}
        </div>
      );
    case "multiselect":
      return (
        <SelectComponent
          options={optionList || []}
          value={optionList?.filter((eachOption) => formData[name]?.includes(eachOption.value))}
          onChange={onChange}
          showSearch={optionList?.length > 5}
          disabled={(disabled || isFormDisabled) && !noDisabled}
          id={id}
          apiCall={apiCall}
          name={name}
          multiSelect
          // displayValue={formData[displayValueKey] ?? displayName}
          displayValue={formData[name]?.map((val) => val.label).toString()}
          label={label}
          // isOpen,onClose,ref,showSearch,name,value,onClick,id,disabled,selectedOptions,options
          className={`form-select rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0`}
        />
      );
    case "person":
      return (
        <SelectComponent
          options={optionList || []}
          value={optionList?.filter((eachOption) => formData[name]?.includes(eachOption.value))}
          onChange={onChange}
          showSearch={optionList?.length > 5}
          disabled={(disabled || isFormDisabled) && !noDisabled}
          id={id}
          name={name}
          multiSelect
          personList
          // value={value}
          displayValue={formData[displayValueKey] ?? displayName}
          label={label}
          // isOpen,onClose,ref,showSearch,name,value,onClick,id,disabled,selectedOptions,options
          className={`form-select rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0`}
        />
      );
    case "time":
      return (
        // <TimeElement formKey={name} name={name} disabled={isFormDisabled && !noDisabled} onChange={onChange} />
        <>
          <TimePickerComponent
            id={name}
            name={name}
            value={formData?.[name] ? convertTimeToDateObj(formData[name]) : null}
            onChange={(date) => {
              console.log(date, "helllloinputtt 1");
              const formattedTime = date ? formatTime(date) : null;
              onChange({ target: { name, value: formattedTime } });
            }}
            placeholder="Select Time"
            size="medium"
            popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
          />
          {console.log(formData, "hellloformmmmm")}
        </>
      );

    case "text":
      return (
        // <input
        //   type="text"
        //   id={id}
        //   name={name}
        //   disabled={isFormDisabled && !noDisabled}
        //   // placeholder="Enter Subject"
        //   value={value}
        //   onChange={(e) => {
        //     console.log(e.target.value, "e.target.value");
        //     onChange(e);
        //   }}
        //   className={` rounded border ${isFormDisabled && !noDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"}  focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5  text-xs block w-full h-7 `}
        // />
        <InputComponent
          type={inputType}
          id={id}
          name={name}
          value={value}
          onChange={(e) => onChange(e)}
          isDisabled={isFormDisabled && !noDisabled}
          inputClassName={` h-[30px] text-xs`}
          placeholder={placeholder ? placeholder : "Select Text"}
          mandatory={mandatory}
          icon={InputEndIcon}
        />
      );
    case "hours":
      return (
        <div className="w-[50%] rounded-md">
          {/* <input
            type="number"
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            disabled={(isFormDisabled || disabled) && !noDisabled}
            className={`rounded-md border h-8 border-DFE2E5 text-434852 text-xs block w-full px-2 ${(isFormDisabled || disabled) && !noDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"}`}
            min="0"
          /> */}
          <InputComponent
            type="number"
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            isDisabled={isFormDisabled && !noDisabled}
            inputClassName={` h-[30px] text-xs`}
            min="0"
            showArrow
          />
        </div>
      );

    case "tags":
      return (
        <div className="w-full">
          <SelectComponent
            options={optionList || []}
            value={formData[name]}
            onChange={(e) => onChange({ target: { name, value: e.target.valueObj } })}
            showSearch={optionList?.length > 5}
            disabled={(disabled || isFormDisabled) && !noDisabled}
            id={id}
            apiCall={apiCall}
            name={name}
            multiSelect
            // displayValue={formData[displayValueKey] ?? displayName}
            // displayValue={formData[name]}
            label={label}
            // isOpen,onClose,ref,showSearch,name,value,onClick,id,disabled,selectedOptions,options
            className={`form-select rounded border ${isFormDisabled || disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0`}
          />
        </div>
      );
    case "number":
      return (
        <div className="w-full rounded-md">
          <input
            type="number"
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            disabled={isFormDisabled && !noDisabled}
            className={`rounded-md border h-9 border-DFE2E5 text-434852 text-xs block w-full focus:outline-hidden focus:ring-0 p-2 ${isFormDisabled && !noDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"}`}
            {...(!isNegativeValue && { min: 0 })}
          />
        </div>
      );
    case "file":
      return (
        <input
          type="file"
          id={id}
          name={name}
          disabled={(isFormDisabled || disabled) && !noDisabled}
          // placeholder="Enter Subject"
          value={value}
          onChange={onChange}
          className={` rounded border ${(isFormDisabled || disabled) && !noDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"}  focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5  text-xs block w-full `}
        />
      );
    case "textArea":
      return (
        <TextAreaComponent
          type="textArea"
          id={id}
          name={name}
          value={value}
          onChange={(e) => onChange(e)}
          className={`text-xs cursor-pointer ${className}`}
          placeholder={placeholder ? placeholder : "Enter Text Here..."}
          mandatory={mandatory}
        />
      );
    // case "dateTimeCombo":
    //   return (
    //     <DateTimeCombo
    //       id={id}
    //       name={name}
    //       label={label}
    //       onChange={onChange}
    //       disabled={disabled}
    //       isFormDisabled={isFormDisabled}
    //       formData={formData}
    //       innerLabel={label}
    //     />
    //   );
    case "radio":
      return (
        <div className="flex gap-4 my-1">
          {optionList?.map((option) => (
            <label key={option?.value} className="flex items-center gap-x-2 text-xs cursor-pointer">
              <input
                type="radio"
                id={`${name}-${option.value}`}
                name={name}
                value={option.value}
                checked={String(value) === String(option.value)}
                onChange={(e) => onChange(e)}
                disabled={isFormDisabled && !noDisabled}
                className="accent-[#004EFF] cursor-pointer ring-0 focus:ring-0 outline-none"
              />
              {option?.label}
            </label>
          ))}
        </div>
      );
    case "assigned_to":
      return (
        <div className="basis-5/5 col-span-1">
          <DelegationMultiSelect
            noLabel
            formData={formData}
            isFormDisabled={props?.isFormDisabled}
            isSearchBarOpen={props?.isSearchBarOpen}
            taskassignedtoref={props?.taskassignedtoref}
            handleMouseEnter={props?.handleMouseEnter}
            handleMouseLeave={props?.handleMouseLeave}
            handleCheck={props?.handleCheck}
            personTableData={props?.personTableData || []}
            handleSelectPerson={props?.handleSelectPerson}
            handleRemovePerson={props?.handleRemovePerson}
            searchTerm={props?.searchTerm}
            isEditTask={props?.isEditTask}
            depth="D0"
            personCountAllowed={1}
            className="font-600"
          />
        </div>
      );
    case "displayValue":
      return (
        <div
          onClick={onClick}
          className={`${className}flex justify-between items-center text-xs border rounded-md border-DFE2E5 text-868686 w-full p-2 cursor-pointer`}
        >
          {value}
          <RightArrow />
        </div>
      );
    default:
      break;
  }
};

export default FieldElements;
